module.exports = __webpack_public_path__ + "static/img/calendar-512.ee7a9394.png";